import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import { config } from '../../../config';

const Profile = () => {
    const { user, token, login } = useAuth();
    const [profile, setProfile] = useState({
        customerId: '',
        name: '',
        email: '',
        contactNumber: '',
        addressStreet: '',
        addressCity: '',
        addressState: '',
        addressZip: '',
        password: ''
    });
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        if (user) {
            setProfile({
                customerId: user.customerId || '',
                name: (user.firstname || '') + ' ' + (user.lastname || ''),
                email: user.email || '',
                contactNumber: user.contactNumber || '',
                addressStreet: user.address?.street || '',
                addressCity: user.address?.city || '',
                addressState: user.address?.state || '',
                addressZip: user.address?.zip || '',
                password: ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = () => setEditing(true);
    const handleSave = async () => {
        setEditing(false);
        if (!user) return;
        try {
            const [firstname, ...lastnameArr] = profile.name.split(' ');
            const updatedUser = {
                firstname,
                lastname: lastnameArr.join(' '),
                email: profile.email,
                contactNumber: profile.contactNumber,
                address: {
                    street: profile.addressStreet,
                    city: profile.addressCity,
                    state: profile.addressState,
                    zip: profile.addressZip
                },
            };
            if (profile.password) updatedUser.password = profile.password;
            const response = await axios.put(
                `${config.API_BASE}/api/users/${user._id}`,
                updatedUser,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200) {
                login(response.data, token); // update context/localStorage
                alert('Profile updated successfully!');
            } else {
                alert('Failed to update profile');
            }
        } catch (err) {
            alert('Failed to update profile');
            console.log(err);
        }
    };

    return (
        <div style={{ maxWidth: 600, margin: '0 auto', padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <h2 style={{ color: '#F28123', marginBottom: 24 }}>Profile</h2>
            <form>
                <div className="form-group mb-3">
                    <label>Customer ID</label>
                    <input name="customerId" value={profile.customerId} disabled className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Name</label>
                    <input name="name" value={profile.name} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Email</label>
                    <input name="email" value={profile.email} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Contact Number</label>
                    <input name="contactNumber" value={profile.contactNumber} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Street Address</label>
                    <input name="addressStreet" value={profile.addressStreet} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>City</label>
                    <input name="addressCity" value={profile.addressCity} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>State</label>
                    <input name="addressState" value={profile.addressState} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Zip Code</label>
                    <input name="addressZip" value={profile.addressZip} onChange={handleChange} disabled={!editing} className="form-control" />
                </div>
                <div className="form-group mb-3">
                    <label>Password</label>
                    <input name="password" type="password" value={profile.password} onChange={handleChange} disabled={!editing} className="form-control" placeholder="Change password" />
                </div>
                {!editing ? (
                    <button type="button" className="btn btn-warning" onClick={handleEdit}>Edit</button>
                ) : (
                    <button type="button" className="btn btn-success" onClick={handleSave}>Save</button>
                )}
            </form>
        </div>
    );
};

export default Profile; 